<template>
  <tr>
    <td @click="handleProductClick" class="product-thumbnail">
      <b-link @click="handleProductClick">
        <img
          v-if="
            product.imgURLS &&
              Array.isArray(product.imgURLS) &&
              product.imgURLS[0]
          "
          :src="product.imgURLS[0].url"
          :alt="product.name"
          style="height: 100px;"
        />
        <img
          v-else
          src="@/assets/resourceBlocks/defaultProduct.jpg"
          alt="product"
          style="height: 100px;"
        />
      </b-link>
    </td>

    <td class="product-name">
      <b-link @click="handleProductClick">{{ product.name }}</b-link>
    </td>

    <td class="product-price">
      <span class="unit-amount">${{ product.price }}</span>
    </td>

    <td class="product-quantity">
      <div v-if="v2" class="input-counter">
        <b-button
          @click="handleMinusQuantityClick"
          class="minus-btn btn-primary"
          >-</b-button
        >
        <input
          type="text"
          class="qtyInput"
          min="1"
          :value="product.productQuantity"
        />
        <b-button @click="handlePlusQuantityClick" class="plus-btn btn-primary"
          >+</b-button
        >
      </div>
      <div>
        {{ product.productQuantity }}
      </div>
    </td>

    <td class="product-subtotal">
      <span class="subtotal-amount">${{ product.totalPrice }}</span>

      <b-link @click="handleRemoveFromCart" class="remove">
        Remove
      </b-link>
    </td>
  </tr>
</template>

<script>
export default {
  name: "CartProduct",
  props: {
    product: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      v2: false
    };
  },
  methods: {
    handleMinusQuantityClick() {
      this.$emit("quantity-minus", this.product);
    },
    handlePlusQuantityClick() {
      this.$emit("quantity-plus", this.product);
    },
    handleProductClick() {
      console.log("Product Selected");
      this.$emit("product-selected", this.product);
    },
    handleRemoveFromCart() {
      this.$emit("remove-from-cart", this.product);
    },
    handleGoToGrid() {
      this.$emit("go-to-storefront");
    }
  }
};
</script>

<style type="css">
.qtyInput {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: hidden;
  background-color: #eee;
  margin: 5px;
  width: 50px;
  text-align: center;
}
</style>
